import React, { useEffect, useRef, useState } from 'react'
import "./auth.css"
import Navbar from '../../Layout/NavBar'
import TextField from '@mui/material/TextField';
import axios from 'axios';
import AlertBox from '../../components/alert/AlertBox';
import { useNavigate } from 'react-router-dom';
import RingLoader from '../../components/loaders/ringLoader/RingLoader';
import { useDispatch, useSelector } from 'react-redux';
import { updateLoginFlg } from '../../redux/features/login/loginSlice';
import { removeEnrollFlg } from '../../redux/features/enroll/enrollSlice';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';




const alertStateInitials = {
  show: false,
  msg: "",
  type: "success"
}




function Enroll() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const fbp = useSelector(state => state.fb?.fbp)
  const fbc = useSelector(state => state.fb?.fbc)
  const payent_id = localStorage.getItem("payent_id");

  const [formData, setFormData] = useState({
    fName: "",
    lName: "",
    email: "",
    password: "",
    cnfrmPassword: "",
    mobNum: "",
    whatsAppNum: "",
    gender: 'm',
    // date_of_birth: ""
  })
  const [err, setErr] = useState({
    fName: "",
    lName: "",
    email: "",
    password: "",
    mobNum: "",
    whatsAppNum: "",
    gender: '',
    // date_of_birth: ""
  })


  const [alertState, setAlertState] = useState(alertStateInitials)
  const [loading, setLoading] = useState(false)
  const scrollRef = useRef(null)

  useEffect(() => {
    
    if (window.gtag) {
      console.log("DSA Siplified conversion tag triggered called");
      window.gtag('event', 'conversion', {
        'send_to': 'AW-11519620914/Q8cGCMK_4IMaELLu_fQq',
        'transaction_id': payent_id || "", // Dynamically pass transaction ID here if available
      });
    } else {
      console.log("DSA Siplified conversion tag triggered failed");
    }
  }, []);


  useEffect(() => {
    
    const generate_fb_purchaseEvent = async () => {
      const body = {
        event_source_url: window.location.href,
        browser_id: fbp,
        click_id: fbc,
        subscription_id: payent_id,
        currency: "INR",
        value: 299,
      }
      await axios.post(process.env.REACT_APP_SERVER + "/api/v1/fb-event/purchase", body)
        .then((res) => {
          console.log(res.data?.message);
        })
        .catch((err) => {
          console.error(err.data?.message);
        })
    }
    generate_fb_purchaseEvent()
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (alertState?.show) {
      scrollRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      //window.scrollBy(0, -20)
    }
  }, [alertState?.show])

  const validate = (obj) => {
    if (obj?.mobNum?.length !== 10) {
      return {
        status: false,
        message: "Invalid Mob Number"
      }
    }
    else if (obj?.whatsAppNum && obj?.whatsAppNum?.length !== 10) {
      return {
        status: false,
        message: "Invalid WhatsApp Number"
      }
    }

    else if (obj?.cnfrmPassword !== obj?.password) {
      return {
        status: false,
        message: "Password does not matched !"
      }
    }
    return {
      status: true,
      message: ""
    }
  }
  const onSubmit = async (e) => {
    e.preventDefault()
    const body = formData
    const fbEventData = {
      event_source_url: window.location.href,
      email: formData?.email,
      phone: formData?.mobNum,
      gender: formData?.gender,
      // date_of_birth: formData?.date_of_birth,
      surname: formData?.lName,
      first_name: formData?.fName,
      // town_city: "New York",
      // county_region: "NY",
      // postcode: "10001",
      // country: "US",
      browser_id: fbp, // Send Browser ID (fbp)
      click_id: fbc,  // Send Click ID (fbc)
      subscription_id: localStorage.getItem("payent_id")
    }

    console.log(fbEventData);

    const validateObj = validate(body)

    if (!validateObj.status) {
      setAlertState({
        show: true,
        type: "error",
        msg: validateObj?.message
      })
      return
    }
    setAlertState(alertStateInitials)
    setLoading(true)
    await axios.post(process.env.REACT_APP_SERVER + "/api/v1/auth/enroll", body)
      .then((res) => {
        const content = res.data.content

        if (res.data?.success) {
          setAlertState({
            show: true,
            type: "success",
            msg: res.data?.message
          })

          dispatch(updateLoginFlg(true))


          axios.post(process.env.REACT_APP_SERVER + "/api/v1/fb-event/complete-registration", fbEventData).then(res => {
            console.log("complete-registration-event:", res.data);
          }).catch(err => {
            console.log(err);

          })



          navigate("/dashboard")

        } else {
          setAlertState({
            show: true,
            type: "error",
            msg: res.data?.message
          })
        }
      })
      .catch((error) => {
        const content = error?.response?.data
        if (content) {
          setAlertState({
            show: true,
            type: "error",
            msg: content?.message
          })
        }
        else {
          setAlertState({
            show: true,
            type: "error",
            msg: error?.message
          })
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleTextChange = (e) => {
    const { name, value } = e.target

    setAlertState(alertStateInitials)

    if (!value) {
      setErr({ ...err, [name]: true })
    } else {
      setErr({ ...err, [name]: false })
    }

    setFormData({ ...formData, [name]: value })
  }

  const handleSelectChange = (e) => {
    const { name, value } = e.target

    setAlertState(alertStateInitials)

    if (!value) {
      setErr({ ...err, [name]: true })
    } else {
      setErr({ ...err, [name]: false })
    }

    setFormData({ ...formData, [name]: value })
  }

  const handleDateChange = (newValue) => {
    console.log(newValue);

  }

  return (
    <div ref={scrollRef} className='auth-page'>
      <Navbar type={2} />
      <div className='auth-content-wp'>

        <form onSubmit={onSubmit} class="form">

          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 34 34" height="34" width="34">
              <path stroke-linejoin="round" stroke-width="2.5" stroke="#115DFC" d="M7.08385 9.91666L5.3572 11.0677C4.11945 11.8929 3.50056 12.3055 3.16517 12.9347C2.82977 13.564 2.83226 14.3035 2.83722 15.7825C2.84322 17.5631 2.85976 19.3774 2.90559 21.2133C3.01431 25.569 3.06868 27.7468 4.67008 29.3482C6.27148 30.9498 8.47873 31.0049 12.8932 31.1152C15.6396 31.1838 18.3616 31.1838 21.1078 31.1152C25.5224 31.0049 27.7296 30.9498 29.331 29.3482C30.9324 27.7468 30.9868 25.569 31.0954 21.2133C31.1413 19.3774 31.1578 17.5631 31.1639 15.7825C31.1688 14.3035 31.1712 13.564 30.8359 12.9347C30.5004 12.3055 29.8816 11.8929 28.6437 11.0677L26.9171 9.91666"></path>
              <path stroke-linejoin="round" stroke-width="2.5" stroke="#115DFC" d="M2.83331 14.1667L12.6268 20.0427C14.7574 21.3211 15.8227 21.9603 17 21.9603C18.1772 21.9603 19.2426 21.3211 21.3732 20.0427L31.1666 14.1667"></path>
              <path stroke-width="2.5" stroke="#115DFC" d="M7.08331 17V8.50001C7.08331 5.82872 7.08331 4.49307 7.91318 3.66321C8.74304 2.83334 10.0787 2.83334 12.75 2.83334H21.25C23.9212 2.83334 25.2569 2.83334 26.0868 3.66321C26.9166 4.49307 26.9166 5.82872 26.9166 8.50001V17"></path>
              <path stroke-linejoin="round" stroke-linecap="round" stroke-width="2.5" stroke="#115DFC" d="M14.1667 14.1667H19.8334M14.1667 8.5H19.8334"></path>
            </svg>
          </div>
          {alertState?.show && <AlertBox type={alertState?.type} msg={alertState?.msg} />}
          <div class="note">
            <label class="title">Create Account</label>

            {/* <ol style={{paddingLeft: "25px"}} className='subtitle'>
        <li>Fill the form</li>
        <li>Make Payment</li>
      </ol> */}
          </div>

          <div className='name_input_wp'>
            <TextField onChange={handleTextChange} name='fName' error={err?.fName}
              required className='fName_input' id="outlined-basic" type="text" label="First Name" variant="outlined" />

            <TextField onChange={handleTextChange} name='lName' error={err?.lName} className='lName_input' id="outlined-basic" type="text" label="Last Name" variant="outlined" />
          </div>


          <TextField onChange={handleTextChange} name='email' error={err?.email}
            required className='email_input' id="outlined-basic" type="email" label="Email" variant="outlined" />

          <TextField onChange={handleTextChange} name='mobNum' error={err?.mobNum} required className='mob_num' id="outlined-basic" type="number" label="Contact Number" variant="outlined" />

          <TextField onChange={handleTextChange} name='whatsAppNum' error={err?.whatsAppNum} className='mob_num' id="outlined-basic" type="number" label="WhatsApp Number" variant="outlined" />

          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Gender</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={formData?.gender}
              label="Gender"
              onChange={handleSelectChange}
              name='gender' error={err?.gender} required
            >
              <MenuItem value={'m'}>Male</MenuItem>
              <MenuItem value={'f'}>Female</MenuItem>
            </Select>
          </FormControl>

          <TextField onChange={handleTextChange} name='password' error={err?.password}
            required className='pwd' id="outlined-basic" type="password" label="Set Password" variant="outlined" />

          <TextField onChange={handleTextChange} name='cnfrmPassword' error={err?.cnfrmPassword} required className='confrm_pwd' id="outlined-basic" type="password" label="Confirm Password" variant="outlined" />



          <button type='submit' class="submit">
            {loading ?
              <RingLoader /> :
              "Proceed"
            }
          </button>
        </form>
      </div>
    </div>
  )
}

export default Enroll